import { Alert } from '@mui/material';
import { danger } from '../../../../images/others';
import { t } from 'i18next';
import { Link } from 'react-router-dom';

const ErrorAlert = () => (
  <Alert
    severity="info"
    icon={<img src={danger} alt="danger" />}
    className="!w-full"
    sx={{
      '& .MuiAlert-message': {
        width: 'auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      },
    }}
  >
    <div className="py-2 text-primary">
      <div className="text-xs"></div>
      <div className="text-xs font-medium">
        {t('defi.myCloudk.licenses.modalAddUtility.error')} {'  '}
        <Link to="/support">{t('dynamic.wallet.history.contactSupport')}.</Link>
      </div>
    </div>
  </Alert>
);

export default ErrorAlert;
